var objTicketComments = {
    // <summary>
    // This object holds all functions for comment related functionality in ticket.js
    // </summary>

    _loadCommentsForm: function (me) {
        /// <summary>
        ///  This function loads the comment form for the given ticket
        /// </summary>
        try {
            if (me.error) { return false; }
            const commentsDivId = "divComments_" + me.vcgid;

            me.myHtml.rowComments.wrapper.show();
            if (me.entry.Id == -1) {
                const div = me.fnd(".ticket-comments");
                div.empty().html($("<div>").addClass("note").html(me.specific.resources.saveBeforeEdit || "Bitte speichern Sie das Ticket, um Kommentare zu bearbeiten."));
                return true;
            }

            var div = me.fnd(".ticket-comments");

            // In print mode: load server-side rendered HTML (no interactive widget needed)
            if (me.specific.print) {
                div.empty().html(me.getLoadingIcon());
                me.getData({ "typeid": 12, "TicketID": me.entry.Id }, function (result) {
                    if (result === null || result === false || result.length === 0) {
                        div.empty();
                        me.myHtml.rowComments.wrapper.hide();
                        return;
                    }
                    div.empty().html(result);
                    // override flex/overflow from Comments.css so all comments are shown in print mode (otherwise some comments are hidden)
                    div.find(".vc-user-notification-comments").css({ "overflow": "visible", "height": "auto" });
                    div.find(".uncc-history").css({ "overflow": "visible", "height": "auto" });
                });
                return true;
            }

            var old = div.find("#" + commentsDivId);
            if (old.length) {
                try {
                    old.UserNotificationComments("destroy");
                } catch (ex) {
                    me._writeErr(ex);
                }
            }

            div.empty();
            var commentsRoot = $("<div>").attr("id", commentsDivId).width(me.myHtml.rowComments.wrapper.width());

            commentsRoot.height(me.myHtml.rowComments.wrapper.height());

            div.append(commentsRoot);

            commentsRoot.UserNotificationComments({
                invokeType: "addVisualBase",
                blid: me.entry.Blid,
                parameter: { AssignId: me.entry.Id, AssignTypeId: 1 }
            });

        } catch (ex) { me._writeErr(ex); }
    }
};